import { combineReducers } from 'redux';
import { List } from 'immutable';
import { AGGREGATED_OVERVIEW_DATA_FETCH_FAILED, AGGREGATED_OVERVIEW_DATA_FETCH_SUCCEEDED, BUILD_BREADCRUMBS, INITIAL_OVERVIEW_DATA_FETCH_SUCCEEDED, SELECT_DEAL_SIDEBAR_ID, SELECT_TEAM, TOGGLE_IS_AGGREGATED_DEAL_ROLL_UP_FETCHING, TOGGLE_IS_AGGREGATED_GOALS_FETCHING, TOGGLE_IS_AGGREGATED_SUBMISSIONS_FETCHING } from '../actions/ActionTypes';
import { getValueForPortalFromLocalStorage } from '../utils/localStorageHelper';
import { SELECTED_TEAM_ID_STORAGE_KEY } from '../utils/localStorageKeys';
import { DEALS_TAB } from '../constants/OverviewConstants';
function isAggregatedDealRollupFetching(state = true, action) {
  switch (action.type) {
    case TOGGLE_IS_AGGREGATED_DEAL_ROLL_UP_FETCHING:
      return action.payload;
    default:
      return state;
  }
}
function isAggregatedGoalsFetching(state = true, action) {
  switch (action.type) {
    case TOGGLE_IS_AGGREGATED_GOALS_FETCHING:
      return action.payload;
    default:
      return state;
  }
}
function isAggregatedSubmissionsFetching(state = true, action) {
  switch (action.type) {
    case TOGGLE_IS_AGGREGATED_SUBMISSIONS_FETCHING:
      return action.payload;
    default:
      return state;
  }
}
function isAggregatedDataFetchSuccessful(state = false, action) {
  switch (action.type) {
    case AGGREGATED_OVERVIEW_DATA_FETCH_SUCCEEDED:
      return true;
    case AGGREGATED_OVERVIEW_DATA_FETCH_FAILED:
      return false;
    default:
      return state;
  }
}
function isInitialOverviewFetchSuccessful(state = false, action) {
  switch (action.type) {
    case INITIAL_OVERVIEW_DATA_FETCH_SUCCEEDED:
      return true;
    default:
      return state;
  }
}
function selectedTeamId(state = getValueForPortalFromLocalStorage(SELECTED_TEAM_ID_STORAGE_KEY, null), action) {
  switch (action.type) {
    case SELECT_TEAM:
      return action.payload;
    default:
      return state;
  }
}
function breadcrumbTrail(state = List(), action) {
  switch (action.type) {
    //Keeping these separate for debugging purposes
    case BUILD_BREADCRUMBS:
      return action.payload;
    default:
      return state;
  }
}
function dealSidebar(state = {
  dealSidebarId: null,
  isTeam: false,
  defaultTab: DEALS_TAB
}, action) {
  switch (action.type) {
    case SELECT_DEAL_SIDEBAR_ID:
      return action.payload;
    default:
      return state;
  }
}
export default combineReducers({
  isAggregatedDealRollupFetching,
  isAggregatedGoalsFetching,
  isAggregatedSubmissionsFetching,
  isAggregatedDataFetchSuccessful,
  isInitialOverviewFetchSuccessful,
  selectedTeamId,
  breadcrumbTrail,
  dealSidebar
});